import { Component } from "@angular/core";

@Component({
  selector: "app-miles-per-year-modal",
  templateUrl: "./miles-per-year-modal.component.html",
  styleUrls: ["./miles-per-year-modal.component.scss"]
})
export class MilesPerYearModalComponent {}
